// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_h3-0";
export var fulfillmentPanelBody = "_h3-1";